import { Modal, Spinner } from 'react-bootstrap'

export const ModalLoading = ({showModalLoading}) => {
    return (
        <Modal show={showModalLoading} onHide={() => {}} centered>
            <Modal.Body>
                <Spinner animation="border" style={{color: '#e58f2f'}}>
             
                </Spinner>
                <span className="ms-2">Cargando...</span>
            </Modal.Body>
        </Modal>
    )
}